export function formatFazaDate(datetime) {
    if (!datetime) return "";
    const d = new Date(datetime);
    if (isNaN(d.getTime())) return datetime;

    const dd = String(d.getDate()).padStart(2, "0");
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const yyyy = d.getFullYear();
    const hh = String(d.getHours()).padStart(2, "0");
    const min = String(d.getMinutes()).padStart(2, "0");

    return `${dd}.${mm}.${yyyy} ${hh}:${min}`;
  }

  export function  formatDate(date) {
    const d = new Date(date);
    if (isNaN(d.getTime())) return "";
    return `${String(d.getDate()).padStart(2, "0")}.${String(
      d.getMonth() + 1
    ).padStart(2, "0")}.${d.getFullYear()}`;
  }

  export function   formatBroj(id) {
    return `${String(id).padStart(3, "0")}/${new Date().getFullYear()}`;
  }